angular.module('notifications', ['growlNotifications']);

angular.module('notifications')

.component('notifications', {
  template: require('./notifications.html'),
  controller: [
    '$rootScope',
    function($rootScope) {
      var $ctrl = this;
      $ctrl.$onInit = function() {
        $ctrl.messages = [];
      };
      $rootScope.$on('onBackendError', function($event, $payload) {
        $ctrl.messages.push({
          id: parseInt(Math.random() * 10000),
          text: $payload,
          error: true
        });
      });
      $rootScope.$on('onBackendSuccess', function($event, $payload) {
        $ctrl.messages.push({
          id: parseInt(Math.random() * 10000),
          text: $payload,
          ok: true
        });
      });
    }
  ]
});



// WEBPACK FOOTER //
// ./src/lib/notifications/notifications.js